import { render, staticRenderFns } from "./ProductSeven.vue?vue&type=template&id=5d0900a8&"
import script from "./ProductSeven.vue?vue&type=script&lang=js&"
export * from "./ProductSeven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0900a8')) {
      api.createRecord('5d0900a8', component.options)
    } else {
      api.reload('5d0900a8', component.options)
    }
    module.hot.accept("./ProductSeven.vue?vue&type=template&id=5d0900a8&", function () {
      api.rerender('5d0900a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductSeven.vue"
export default component.exports